// revenueCatSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomerInfo } from '@revenuecat/purchases-capacitor';
import type { RootState } from 'common/store/store';

interface RevenueCatState {
  hasPremiumSubscription: boolean;
  customerInfo: CustomerInfo | null;
}

const initialState: RevenueCatState = {
  hasPremiumSubscription: false,
  customerInfo: null,
};

const revenueCatSlice = createSlice({
  name: 'revenueCat',
  initialState,
  reducers: {
    setSubscriptionStatus: (
      state,
      action: PayloadAction<{ hasPremiumSubscription: boolean; customerInfo: CustomerInfo | null }>,
    ) => {
      state.hasPremiumSubscription = action.payload.hasPremiumSubscription;
      state.customerInfo = action.payload.customerInfo;
    },
  },
});

export const { setSubscriptionStatus } = revenueCatSlice.actions;

export default revenueCatSlice.reducer;

// Selectors
export const selectHasPremiumSubscription = (state: RootState) => state.revenueCat.hasPremiumSubscription;

export const selectCustomerInfo = (state: RootState) => state.revenueCat.customerInfo;
